import type { PumsemTableColumn } from '../model/pumsem.type';
import type { PumsemColumnGroup } from '../model/pumsemTable.type';

/**
 * 상위 헤더로 열을 묶는다 — 발행본 표의 `colspan` 이 이 모양이다.
 *
 * **연속**일 때만 묶는다. 사이에 다른 열이 낀 같은 이름 두 묶음을 하나로 합치면
 * 헤더가 실제 열 위치와 어긋난다.
 */
export function groupColumns(
  columns: PumsemTableColumn[],
): PumsemColumnGroup[] {
  const groups: PumsemColumnGroup[] = [];
  for (const column of columns) {
    const label = column.group?.trim() ? column.group : null;
    const last = groups[groups.length - 1];
    if (last && label !== null && last.label === label) {
      last.columns.push(column);
    } else {
      groups.push({ label, columns: [column] });
    }
  }
  return groups;
}
